<template>
    <div class="tw-flex tw-items-start tw-flex-col tw-w-full">
        <div class='tw-w-full'>
            <label :for="id ? id : 'fileInput'" class="cu-btn-success">
                <!-- cu-btn-success verbietet Zeilenumbrüche; auf schmalen Bildschirmen darf "Upload" in die nächste Zeile -->
                <span class="tw-whitespace-normal">
                    <input style="display: inline-block;" class="tw-max-w-full" type="file" :id="id ? id : 'fileInput'" @change="uploadFiles()" ref="fileInput"
                        multiple :accept="acceptFileTypes">

                    <i class="fa fa-cloud-upload tw-mr-2 tw-inline-block"></i> Upload
                </span>

                <input type="hidden" :name="'attachment_ids[]'" v-for="attachmentId in attachmentIds"
                       :value="attachmentId">
            </label>
        </div>

        <ul class="tw-block tw-mb-0 tw-list-inside tw-list-disc tw-mt-4 ml-6" v-show="uploadedFiles.length > 0">
            <li v-for="file in uploadedFiles">
                <a class="cu-link" :href="'/attachments/' + file.id" target="_blank" v-text="file.filename"></a>
                <i class="fa fa-times tw-text-danger-primary tw-ml-1 tw-cursor-pointer fileupload-delete"
                   @click="deleteAttachment(file)"></i>
            </li>
        </ul>
    </div>
</template>

<script>
    import axios from "axios";
    import Vue from 'vue';

    export const EventBus = new Vue();

    export default {
        props: {
            id: {
                type: String,
                required: true,
            },

            attachmentTypeId: {
                type: Number,
                required: true,
            },

            acceptFileTypes: {
                type: String,
                required: false,
                default: '*/*',
            }
        },

        data() {
            return {
                uploadedFiles: [],
            }
        },

        computed: {
            attachmentIds() {
                let ids = [];

                if (this.uploadedFiles.length > 0) {
                    this.uploadedFiles.forEach(item => {
                        ids.push(item.id);
                    });
                }

                return ids;
            }
        },

        methods: {
            deleteAttachment(file) {
                this.uploadedFiles = this.uploadedFiles.filter(uploadedFile => {
                    return uploadedFile.id !== file.id;
                });
                this.$emit('update-attachment-ids', this.attachmentIds);
            },

            clearInput() {
                this.$refs.fileInput.value = '';
            },

            getFormData() {
                let formData = new FormData();

                Array.from(this.$refs.fileInput.files).forEach(file => {
                    formData.append('files[]', file)
                    formData.append('attachment_type_id', this.attachmentTypeId)
                });

                return formData;
            },

            uploadFiles() {
                axios
                    .post(
                        '/attachments',
                        this.getFormData(),
                        { headers: { 'Content-Type': 'multipart/form-data' } }
                    )
                    .then(response => {
                        response.data.forEach(file => {
                            this.uploadedFiles.push(file)
                        });

                        this.clearInput();
                    })
                    .catch(response => {
                        this.clearInput();
                    })
                    .then(() => {
                        this.$emit('update-attachment-ids', this.attachmentIds);
                    });
            }
        },

        mounted() {
            if (this.$attrs.old) {
                const oldData = this.$attrs.old[this.$attrs.index];

                if (oldData && oldData.length > 0) {
                    let attachments = oldData;

                    let that = this;
                    attachments.forEach(function (attachment) {
                        that.uploadedFiles.push(attachment);
                    });
                }
            }

            EventBus.$on('clear-file-upload', id => {
                if (this.$vnode.key === id) {
                    this.uploadedFiles = [];
                }
            });
        }
    }
</script>